export default { Loading: 'Cargando' };
